import React, { createContext, useState } from "react";
import { useNavigate } from "react-router";
import RouteConstants from "../../constants/routeConstants.json";
import ContentData from "../../constants/contentFile.json";
import { validateEmail } from "../../utils/service";
import { forgotPasswordApi } from "../../api/Api";

export const ForgotPasswordContext = createContext({});

export const ForgotPasswordContextProvider = ({ children }) => {
  const pageContent = ContentData.authPage;
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);

  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState();

  // Validation Error message state
  const [validateEmailMsg, setValidateEmailMsg] = useState(" ");

  // function for go back to login
  const navigatepage = () => {
    navigate(RouteConstants.LOGIN);
  };

  // set input value to state using handle change

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Clear validation message in real-time if the input is valid
    if (validateEmail(value)) {
      setValidateEmailMsg(""); // Clear the error message
    }
  };

  const handleEmailBlur = () => {
    emailValidation(email); // Validate email on blur
  };

  // Email validation

  const emailValidation = (value) => {
    if (value === "") {
      setValidateEmailMsg(pageContent.emailRequired);
      return false;
    } else if (!validateEmail(value)) {
      setValidateEmailMsg(pageContent.invalidEmail);
      return false;
    } else {
      setValidateEmailMsg(" ");
      return true;
    }
  };

  // Form submit
  const forgotPasswordSubmit = async (e) => {
    e.preventDefault();
    const userEmail = {
      email: email,
      // url: `${process.env.REACT_APP_HOSTURL}/#/reset-password`,
    };
    if (emailValidation(email)) {
      try {
        setSpinnerStatus(true);
        const getData = await forgotPasswordApi(userEmail);
        if (getData?.status === 200) {
          const successMessage = getData?.data?.message;
          setSpinnerStatus(false);
          setSuccessAlertShow(true);
          setErrorAlertShow(false);
          setSuccessAlertMessage(successMessage);
        }
      } catch (error) {
        const responseStatus = error?.response?.data?.statusCode;
        const errorMessage =
          error?.response?.data?.message || "Something went wrong...";

        setStatusValue(responseStatus);
        setErrorAlertMessage(errorMessage);
        setSpinnerStatus(false);
        setErrorAlertShow(true);

        if (responseStatus === 400) {
          setButtonText(ContentData.tenantPage.tryAgain);
        } else if (responseStatus === 401 || responseStatus === 403) {
          setButtonText(ContentData.tenantPage.login);
        } else {
          setButtonText(ContentData.tenantPage.tryAgain);
        }
      }
    }
  };

  const provideValue = {
    pageContent,
    navigatepage,
    email,
    handleEmailChange,
    emailValidation,
    validateEmailMsg,
    forgotPasswordSubmit,
    errorAlertMessage,
    setErrorAlertShow,
    errorAlertShow,
    spinnerStatus,
    setSuccessAlertShow,
    successAlertMessage,
    successAlertShow,
    buttonText,
    statusValue,
    handleEmailBlur,
  };
  return (
    <ForgotPasswordContext.Provider value={provideValue}>
      {children}
    </ForgotPasswordContext.Provider>
  );
};
